import { fork } from 'redux-saga/effects';

import { fetchUserProfileSaga } from './sagas/fetchUserProfile';
import { createUserProfileSaga } from './sagas/createUserProfile';
import { updateUserProfileSaga } from './sagas/updateUserProfile';
import { updateWidgetsSettingsSaga } from './sagas/updateWidgetsSettings';
import { uploadPhotosSaga } from './sagas/uploadPhotos';

export const userProfileSaga = function* () {
  yield fork(fetchUserProfileSaga);
  yield fork(createUserProfileSaga);
  yield fork(updateUserProfileSaga);
  yield fork(updateWidgetsSettingsSaga);
  yield fork(uploadPhotosSaga);
};
